import { render, staticRenderFns } from "./access-registration-view.vue?vue&type=template&id=77130498&scoped=true&lang=pug"
import script from "./access-registration-view.vue?vue&type=script&lang=js"
export * from "./access-registration-view.vue?vue&type=script&lang=js"
import style0 from "./access-registration-view.vue?vue&type=style&index=0&id=77130498&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77130498",
  null
  
)

export default component.exports